import { render, staticRenderFns } from "./VTableLocal.vue?vue&type=template&id=60bbcc34&scoped=true"
import script from "./VTableLocal.vue?vue&type=script&lang=js"
export * from "./VTableLocal.vue?vue&type=script&lang=js"
import style0 from "./VTableLocal.vue?vue&type=style&index=0&id=60bbcc34&prod&lang=scss&scoped=true"
import style1 from "./VTableLocal.vue?vue&type=style&index=1&id=60bbcc34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbcc34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VDataTable,VRow,VSelect,VSpacer,VSwitch,VToolbar,VToolbarTitle})
